<template>
  <div>
    <page-title
      icon="fa fa-headset"
      main="Suporte"
      sub="Suporte Vegetal"
      :help="true"
      titleHelp="Página responsável pela listagem de Anos Safras"
      content="Suporte Vegetal">
        <template v-slot:actions>
          <base-button
            color="red"
            type="neutral"
            class="ml-3 mt-2 text-red"
            size="sm"
            @click="generatePdf"
            v-loading="isLoadingPdfDownload"
            >Gerar PDF <i class="fa fa-file-pdf"></i>
          </base-button>
          <base-button type="neutral" class="ml-3 mt-2" size="sm" @click="openModal"
            >Novo Ticket
          </base-button>
        </template>
    </page-title>
    <!-- Modal register Demand -->
    <div>
      <div class="col-12 row">
        <template>
          <modal :mouseDownOn="false" :show.sync="modal.registerDemand" size="lg">
            <template slot="header">
              <h5 class="modal-title" id="exampleModalLabel">Cadastrar Ticket</h5>
            </template>
            <validation-observer ref="observer">
                <form role="form" id="formTicket">
                <div class="row justify-content-md-center">
                  <div class="col-12 form-group">
                    <label class="form-control-label">Solicitante</label><br />
                    <base-input :required="true" :error="errors[0]">
                      <multiselect
                        v-model="support.author"
                        :options="users"
                        label="name"
                        track-by="id"
                        select-label=""
                        deselect-label=""
                        placeholder="Selecionar Solicitante"
                        @search-change="getUsers"
                        :selected-label="'Selecionado'"
                        disabled
                      >
                      </multiselect>
                    </base-input>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label">Assunto</label><label style="color: red;"> *</label><br />
                    <ValidationProvider vid="support.subject" name="Assunto" rules="required" v-slot="{ errors }">
                      <base-input :required="true" :error="errors[0]">
                        <input type="text" class="form-control" placeholder="Assunto" v-model="support.subject" />
                      </base-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 form-group">
                    <label class="form-control-label">Serviço</label><br />
                    <multiselect
                      v-model="support.service"
                      :options="services"
                      label="description"
                      track-by="value"
                      select-label=""
                      deselect-label=""
                      placeholder="Selecionar Serviço"
                      :selected-label="'Selecionado'"
                    >
                    </multiselect>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 form-group">
                    <label class="form-control-label">Categoria</label><br />
                    <multiselect
                      v-model="support.category"
                      :options="categories"
                      label="description"
                      track-by="id"
                      select-label=""
                      deselect-label=""
                      placeholder="Selecionar Categoria"
                      :selected-label="'Selecionado'"
                    >
                    </multiselect>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 form-group">
                    <label class="form-control-label">Urgência</label><br />
                    <multiselect
                      v-model="support.urgency"
                      :options="['Crítica', 'Alta', 'Média', 'Baixa']"
                      select-label=""
                      deselect-label=""
                      placeholder="Selecionar Urgência"
                      :selected-label="'Selecionado'"
                    >
                    </multiselect>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label">Mensagem</label><br />
                    <textarea
                      class="form-control"
                      v-model="support.description"
                      rows="3"
                    ></textarea>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label">Responsável</label><br />
                    <multiselect
                      v-model="support.responsible"
                      :options="usersResponsibles"
                      label="name"
                      track-by="value"
                      select-label=""
                      deselect-label=""
                      placeholder="Selecionar Responsável"
                      @search-change="getResponsible"
                      :selected-label="'Selecionado'"
                    >
                    </multiselect>
                  </div>
                  <div class="col-12 form-group">
                    <label class="form-control-label">Anexos</label><br />
                    <div>
                      <file-input :files.sync="support.files" multiple></file-input>
                    </div>
                    <file-list
                      :key="support.id"
                      :files="support.files"
                      :remove=true
                      @remove="support.files = support.files.filter((f) => f != $event)"
                      @remove:file="removeFile"
                    />
                  </div>
                </div>
              </form>
            </validation-observer>
            <template slot="footer">
              <base-button
                type="secondary"
                @click="modal.registerDemand = false"
                class="mr-2"
                >Fechar</base-button
              >
              <base-button v-if="!editSupport" type="success" @click="saveDemand"
                >Salvar</base-button
              >
              <base-button v-else type="success" @click="updateDemand"
                >Editar</base-button
              >
            </template>
          </modal>
        </template>
      </div>

      <!-- Card Status -->
      <div class="row p-3">
        <div class="col-12 col-sm-12 col-md-4" v-for="card in selectionCard" :key="card.title">
          <card cardClasses="card-stats">
            <div class="row">
              <div class="col-auto">
                <div
                  :class="
                    'icon icon-shape text-white rounded-circle shadow bg-gradient-' +
                    color(card)
                  "
                >
                  <i class="ni ni-money-coins"></i>
                </div>
              </div>
              <div class="col">
                <h5 class="card-title text-uppercase text-muted mb-0">
                  {{ card.title }}
                </h5>
                <span class="h2 font-weight-bold mb-0">
                  {{ card.status }}
                </span>
              </div>
            </div>
          </card>
        </div>
      </div>
      <!-- Charts -->
      <div class="card-deck">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h6 class="text-uppercase text-muted ls-1 mb-1">Visualização</h6>
              <h5 class="h3 mb-0">Tickets</h5>
            </div>
          </div>
          <bar-chart
            :height="200"
            ref="barChart"
            :chart-data="redBarChart.chartData"
          >
          </bar-chart>
        </card>
      </div>

      <!-- History Modal Demand -->
      <modal :show.sync="modal.historyDemand" :mouseDownOn="false" size="lg">
        <div class="mt-3 mb-4">
          <h3 class="modal-title col-12" id="exampleModalLabel">
            Histórico do Suporte {{ support && support.id }}#
          </h3>
          <h5 class="text-muted ml-3">
            Histórico detalhado das informações do suporte
          </h5>
        </div>
        <collapse class="lg">
          <collapse-item title="Dados do Suporte">
            <form role="form">
              <validation-observer ref="observer">
                <div class="row justify-content-md-center">
                  <div class="col-6 form-group">
                    <label class="form-control-label h3">Solicitante</label><br />
                    <input disabled type="text" :placeholder="support.author.name" class="form-control" />
                  </div>
                  <div class="col-6 form-group">
                    <label class="form-control-label">Assunto</label><br />
                    <ValidationProvider vid="support.subject" name="Assunto" rules="required" v-slot="{ errors }">
                      <base-input :required="true" :error="errors[0]">
                        <input type="text" class="form-control" placeholder="Assunto" v-model="support.subject" />
                      </base-input>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row justify-content-md-center">
                  <div class="col-4 form-group">
                    <label class="form-control-label">Serviço</label><br />
                    <input disabled type="text" :placeholder="support.service_support_id" class="form-control" />
                  </div>
                  <div class="col-4 form-group">
                    <label class="form-control-label">Categoria</label><br />
                    <input disabled type="text" :placeholder="support.category_support_id" class="form-control" />
                  </div>
                  <div class="col-4 form-group">
                    <label class="form-control-label">Urgência</label><br />
                    <input disabled type="text" :placeholder="support.urgency" class="form-control" />
                  </div>
                </div>
                <div class="row justify-content-md-center">
                  <div class="col-6 form-group">
                    <label class="form-control-label">Mensagem</label><br />
                    <textarea disabled type="text" :placeholder="support.description" class="form-control" />
                  </div>
                  <div class="col-6 form-group">
                    <label class="form-control-label">Responsável</label><br />
                    <input disabled type="text" :placeholder="
                      support.responsible
                        ? support.responsible.name
                        : ''
                    " class="form-control" />
                  </div>
                </div>
                <div class="mt-3 mb-4">
                  <h3 class="mb-0">
                    Relatório Técnico
                  </h3>
                  <h5 class="text-muted mt-0">
                    Relatório técnico do responsável pelo suporte
                  </h5>
                </div>
                <div class="row justify-content-md-center">
                  <div class="col-6 form-group">
                    <label class="form-control-label">Motivo</label><br />
                    <input disabled type="text" :placeholder="sendAnswer.description" class="form-control" />
                  </div>
                  <div class="col-6 form-group">
                    <label class="form-control-label">Descrição</label><br />
                    <textarea disabled type="text" :placeholder="sendAnswer.content" class="form-control" />
                  </div>
                </div>
              </validation-observer>
            </form>
          </collapse-item>
        </collapse>
        <div class="row ml-1">
          <div class="col-5">
            <h4>Histórico</h4>
          </div>
          <div class="col-6">
            <h4>Data</h4>
          </div>
        </div>
        <collapse>
          <collapse-item>
            <template v-slot:title>
              <div class="title-row d-flex justify-content-between align-items-center w-100 mr-7">
                <div class="support-text">
                  {{ "Suporte" }}
                  {{ support && support.id + "#" }}
                </div>  
                <div class="d-flex align-items-center ml-8">
                  <i class="fa fa-clock text-lowercase mr-2"></i>
                  {{ support.created_at | formatDate }}
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-3">
                <h4>Usuário</h4>
              </div>
              <div class="col-2">
                <h4>Local</h4>
              </div>
              <div class="col-2">
                <h4>De</h4>
              </div>
              <div class="col-2">
                <h4>Para</h4>
              </div>
              <div class="col-3">
                <h4>Data</h4>
              </div>
            </div>
            <div v-for="version in versions" :key="version.id">
              <div v-for="obj in Object.keys(version.changes_to_json)" :key="obj.id">
                <div class="row mb-2">
                  <div class="col-3" v-if="obj !== 'Atualização'">
                    {{ version.user_name }}
                  </div>
                  <div class="col-2" v-if="obj !== 'Atualização'">
                    {{obj.toLocaleUpperCase()}}
                  </div>
                  <div class="col-2" v-if="obj !== 'Atualização'">
                    {{version.changes_to_json[obj][0]}}
                  </div>
                  <div class="col-2" v-if="obj !== 'Atualização'">
                    {{version.changes_to_json[obj][1]}}
                  </div>
                  <div class="col-3" v-if="obj !== 'Atualização'">
                    {{ version.changes_to_json['Atualização'][1] | formatDate }}
                  </div>
                </div>
              </div>
            </div>
          </collapse-item>
        </collapse>
        <collapse>
          <collapse-item>
            <div slot="title">
              <div class="row">
                <div>
                  {{ "Anexos"}}
                </div>
              </div>
            </div>
            <div>
              <div class="col-12" style="margin-top: 15px;">
                <file-input :files.sync="support.files" multiple></file-input>
              </div>
              <file-list
                :key="support.id"
                :files="support.files"
                :remove=true
                @remove="support.files = support.files.filter((f) => f != $event)"
                @remove:file="removeFile"
              />
            </div>
          </collapse-item>
        </collapse>
        <template slot="footer">
          <base-button type="secondary" @click="modal.historyDemand = false" class="mr-2">Fechar</base-button>
          <base-button type="success" @click="updateDemand">Enviar</base-button>
        </template>
      </modal>
      <!-- List Data -->
      <div class="card mt-4">
        <div class="card-header mb-3">
          <div class="cols">
            <h5 class="h3 mb-0">Tickets</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <!-- Filters -->
        <div class="col-12 row mb-2 justify-content-md-center">
          <div class="col-12 col-sm-12 col-md-3 form-group">
            <label class="form-control-label">Solicitante</label><br />
            <multiselect
              v-model="search.author"
              :options="users"
              label="name"
              select-label=""
              deselect-label=""
              track-by="value"
              placeholder="Selecionar Solicitante"
              @search-change="getUsers"
              :selected-label="'Selecionado'"
            >
            </multiselect>
          </div>

          <div class="col-12 col-sm-12 col-md-3 form-group">
            <label class="form-control-label">Urgência</label><br />
            <multiselect
              v-model="search.urgency"
              select-label=""
              deselect-label=""
              :options="['Crítica', 'Alta', 'Média', 'Baixa']"
              placeholder="Selecionar Urgência"
              :selected-label="'Selecionado'"
            >
            </multiselect>
          </div>

          <div class="col-12 col-sm-12 col-md-3 form-group">
            <label class="form-control-label">Responsável</label><br />
            <multiselect
              v-model="search.responsible"
              :options="usersResponsibles"
              label="name"
              select-label=""
              deselect-label=""
              track-by="value"
              placeholder="Selecionar Responsável"
              @search-change="getResponsible"
              :selected-label="'Selecionado'"
            >
            </multiselect>
          </div>

          <div class="col-12 col-sm-12 col-md-3 row mt-2">
            <base-button
              style="height: 45px;"
              class="mt-4 ml-3"
              type="success"
              @click="getDemandSupport(null, search)"
              >Pesquisar</base-button
            >
            <base-button
              type="text"
              class="ml-3 mb-2 text-green mt-4"
              style="height: 45px;"
              @click="clearFilter"
              >Limpar<i class="fa fa-eraser"></i>
            </base-button>
          </div>
        </div>

        <el-table
          ref="filterTable"
          v-loading="isLoading"
          :data="supports"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          style="width: 100%;"
        >
          <el-table-column label="Id" prop="id" min-width="100px" sortable />
          <el-table-column
            label="Autor"
            prop="author.name"
            min-width="220px"
            sortable
          ></el-table-column>
          <el-table-column
            label="Demanda"
            prop="subject"
            min-width="220px"
            sortable
          ></el-table-column>
          <el-table-column
            label="Urgência"
            prop="urgency"
            :filter-method="filterUrgency"
            filter-placement="bottom-end"
            :filters="[
              { text: 'CRÍTICA', value: 'CRÍTICA' },
              { text: 'ALTA', value: 'ALTA' },
              { text: 'MÉDIA', value: 'MÉDIA' },
              { text: 'BAIXA', value: 'BAIXA' },
            ]"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            label="Responsável"
            min-width="220px"
            prop="responsible.name"
            sortable
          ></el-table-column>
          <el-table-column label="Dias Abertos" min-width="180px" sortable v-slot="{ row }">
            {{
              row.open_days != "Fechado" ? row.open_days + " Dias" : row.open_days
            }}
          </el-table-column>
          <el-table-column
            label="Status"
            :filter-method="filterTag"
            :filters="[
              { text: 'Concluído', value: 'completed' },
              { text: 'Em Execução', value: 'execution' },
              { text: 'Recebido', value: 'received' },
            ]"
            filter-placement="bottom-end"
            min-width="180px"
          >
            <template slot-scope="scope">
              <el-tag
                :type="getColor(scope.row.status).color"
                disable-transitions
              >
                {{ getColor(scope.row.status).value }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="Ações"
            min-width="100px"
            prop="acoes"
            v-slot="{ row }"
          >
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer;"
            >
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
                <div v-if="row.status !== 'execution'">
                  <a class="dropdown-item" href="#" @click="changeStatus(row.id, 1)"
                    >Iniciar Suporte</a>
                </div>
                <div v-if="row.status !== 'completed'">
                  <a class="dropdown-item" href="#" @click="endModal(row, 2)"
                    >Finalizar Suporte</a
                  >
                </div>
                <div>
                  <a class="dropdown-item" @click="history(row, 2)" href="#" >Histórico Técnico</a>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </el-table-column>
        </el-table>
         <!-- Modal End Demand -->
          <modal :show.sync="modal.endDemand">
            <template slot="header">
              <h5 class="modal-title" id="exampleModalLabel">
                Finalizar Demanda
              </h5>
            </template>
            <form role="form" >
              <div class="row justify-content-md-center">
                <div class="col-12 form-group">
                  <label class="form-control-label">ID</label><br />
                  <input
                    type="text"
                    :placeholder="endModalSelectedRow.author_id"
                    disabled
                    class="form-control"
                  />
                </div>
                <div class="col-12 form-group">
                  <label class="form-control-label">Autor</label><br />
                  <input
                    disabled
                    type="text"
                    :placeholder="support.author.name"
                    class="form-control"
                  />
                </div>
                <div class="col-12 form-group">
                  <label class="form-control-label">Demanda</label><br />
                  <input
                    disabled
                    type="text"
                    :placeholder="endModalSelectedRow.subject"
                    class="form-control"
                  />
                </div>
                <div class="col-12 form-group">
                  <label class="form-control-label">Urgência</label><br />
                  <input
                    disabled
                    type="text"
                    placeholder="Urgência"
                    class="form-control"
                  />
                </div>
                <div class="col-12 form-group">
                  <label class="form-control-label">Dias Abertos</label
                  ><br />
                  <input
                    disabled
                    type="text"
                    :placeholder="
                      endModalSelectedRow.open_days != 'Fechado'
                        ? endModalSelectedRow.open_days + ' Dias'
                        : endModalSelectedRow.open_days
                    "
                    class="form-control"
                  />
                </div>
                <div class="col-12 form-group">
                  <label class="form-control-label">Status</label><br />
                  <input
                    disabled
                    type="text"
                    :placeholder="endModalSelectedRow.status"
                    class="form-control"
                  />
                </div>
                <div class="col-12 form-group">
                  <label class="form-control-label">Responsável</label
                  ><br />
                  <multiselect
                    v-model="sendAnswer.user_id"
                    :options="usersResponsibles"
                    label="name"
                    track-by="id"
                    select-label=""
                    deselect-label=""
                    placeholder="Selecionar Responsável"
                    @search-change="getResponsible"
                    :selected-label="'Selecionado'"
                  >
                  </multiselect>
                </div>
                <div class="col-12 form-group" v-if="currentUser.is_admin || currentUser.id === row.user_id">
                  <label class="form-control-label"
                    >Motivo</label
                  ><br />
                  <textarea
                    type="text"
                    class="form-control"
                    placeholder="Descrição"
                    v-model="sendAnswer.description"
                  />
                </div>
                <div class="col-12 form-group" v-if="currentUser.is_admin || currentUser.id === row.user_id">
                  <label class="form-control-label"
                    >Descrição da solução</label
                  ><br />
                  <textarea
                    type="text"
                    class="form-control"
                    placeholder="Descrição"
                    v-model="sendAnswer.content"
                  />
                </div>
              </div>
            </form>
            <template slot="footer">
              <base-button
                type="secondary"
                @click="modal.endDemand = false"
                class="mr-2"
                >Fechar</base-button
              >
              <base-button
                type="success"
                @click="sendDemandSupportAnswer()"
                >Finalizar Demanda</base-button
              >
            </template>
          </modal>
        <div class="card-footer py-4 d-flex justify-content-end">
          <base-pagination
            v-on:input="changePage"
            v-model="paginated_data['current']"
            :total="paginated_data['count']"
            :perPage="paginated_data['per_page']"
          >
          </base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import FileList from "@/components/FileList";
import BarChart from "@/components/Charts/BarChart";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

import {
  Table,
  TableColumn,
  Tag,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";
import BaseButton from "../../components/BaseButton.vue";

export default {
  components: {
    PageTitle,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    Multiselect,
    BarChart,
    Button,
    BaseButton,
    Collapse,
    CollapseItem,
    FileList,
    ValidationProvider,
  },
  data() {
    return {
      errors: [],
      sendAnswers: {},
      sendAnswer: {
        content: "",
        demand_support_id: "",
        user_id: "",
        description: "",
      },
      allSupports: [],
      categories: [],
      editSupport: false,
      isLoading: false,
      isLoadingDemand: false,
      isLoadingPdfDownload: false,
      paginated_data: [],
      endModalSelectedRow: "",
      redBarChart: {
        chartData: {
          datasets: [
            {
              label: "Suportes",
              data: [],
            },
          ],
        },
      },
      modal: {
        endDemand: false,
        historyDemand: false,
        registerDemand: false,
      },
      versions: [],
      supports: [],
      support: {
        author_id: "",
        subject: "",
        user_id: "",
        status: "",
        service: "",
        category: "",
        urgency: "",
        description: "",
        files: [],
        author: this.$currentUser(),
      },
      selectionCard: [],
      services: [],
      search: {},
      users: [],
      usersResponsibles: [],
      valid: true,
    };
  },
  mounted() {
    this.getSupportServices();
    this.getSupportCategories();
    this.getUsers();
    this.getResponsible();
    this.getDemandSupport();
    this.getAllSupports();
    this.currentUser = this.$currentUser();
  },
  methods: {
    addFile(files) {
      if(files && files.length){
        if (
          this.support &&
          this.support.files
        ) {
          this.support = Object.assign({}, this.support, { files: [...files] });
        }
      }
    },
    removeFile(file) {
      this.$http.secured
        .delete(`/api/v1/demand_supports/${this.support.id}`, {
          params: {
            file: file.id
          }
        })
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    getVersions: function(page){
      this.isLoading  = true;
      if (typeof page === "undefined") page = null;

      this.$http.secured
        .get('/api/v1/admin/demand_support_versions', {
          params: {
            page: page,
            "version[item_type]": "DemandSupport",
            "version[item_id]": this.support.id,
            "version[event]": "update",
          }
        })
        .then((response) => {
          this.paginated_data = response.data
          console.log(response)
          this.versions = response.data['demand_support_versions']
          this.isLoading = false;
        })
         .catch((error) => console.log("Something went wrong", error));

    },
    async getDemandSupportAnswer(id) {
      try {
        const response = await this.$http.secured.get(
          `/api/v1/demand_supports/${id}`
        );
        this.answer = response.data;
      } catch (error) {
        console.log("getDemandSupportAwnser error: ", error);
      }
    },
    async sendDemandSupportAnswer() {
      if (this.sendAnswer.user_id.id)
        this.sendAnswer.user_id = String(this.sendAnswer.user_id.id);
      try {
        const response = await this.$http.secured.post(
          `/api/v1/demand_support_answers/`,
          {
            demand_support_answer: this.sendAnswer,
          }
        );
        this.answer = response.data;
        this.getDemandSupport();
        this.modal.endDemand = false;
      } catch (error) {
        console.log("sendDemandSupportAwnser error: ", error);
      }
    },
    color(status) {
      if (status.title == "Em Execução") return "yellow";
      else if (status.title == "Concluídos") return "success";
      else return "danger";
    },
    changeStatus(id, status) {

      this.$http.secured
        .patch(`/api/v1/demand_supports/`+ id, {
          status: status,
        })
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.editSupport = false;
          this.getAllSupports();
          this.getDemandSupport();
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    changePage(page) {
      this.getDemandSupport(page, this.search);
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
      this.search = {};
      this.getDemandSupport();
    },
    edit(support) {
      this.support = support;
      this.modal.registerDemand = true;
      this.editSupport = true;
    },
    history(support) {
      this.support = support;
      this.getVersions();
      this.modal.historyDemand = true;
    },
    filterTag(value, row) {
      this.search.status = value;
      return row.status === value;
    },
    filterUrgency(value, row) {
      this.search.urgency = value;
      return row.urgency == value;
    },
    getSupportServices() {
      this.$http.secured
        .get("/api/v1/service_supports")
        .then((response) => (this.services = response.data))
        .catch((error) => console.log(error, "Something went wrong"));
    },
    getSupportCategories() {
      this.$http.secured
        .get("/api/v1/category_supports")
        .then((response) => (this.categories = response.data))
        .catch((error) => console.log(error, "Something went wrong"));
    },
    formatDate(dateString) {
      let dateParts = dateString.split('/');
      let finalString = '' + dateParts[1] + '-' + dateParts[0]
      if (dateParts.length > 2) finalString += '-' + dateParts[2]

      return finalString
    },
    getUsers(query) {
      var data = {
        per_page: 10,
        q: { name: query, status: true },
      };

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => (this.users = response.data.users))
        .catch((error) => console.log(error, "Something went wrong"));
    },
    getResponsible(query) {
      var data = {
        per_page: 10,
        q: { name: query, status: true, subject_class: "demand_support", action: 4 },
      };

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => (this.usersResponsibles = response.data.users))
        .catch((error) => console.log(error, "Something went wrong"));
    },
    getAllSupports() {
      this.$http.secured
        .get("/api/v1/demand_supports", { params: { unpaged: true } })
        .then((response) => {
          this.allSupports = response.data;
          this.updateStatus();
          this.setChartData();
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    getDemandSupport(page = null, q = null) {
      let data = {};
      if (q) {
        data.author_id = q.author ? q.author.id : null;
        data.user_id = q.responsible ? q.responsible.id : null;
        data.urgency = q.urgency ? q.urgency : null;
        data.status = q.status ? q.status : null;
      }

      data.author_id == null ? delete data.author_id : data.author_id;
      data.user_id == null ? delete data.user_id : data.user_id;
      data.urgency == null ? delete data.urgency : data.urgency;
      data.status == null ? delete data.status : data.urgency;

      this.$http.secured
        .get("/api/v1/demand_supports", { params: { page: page, q: data } })
        .then((response) => {
          this.paginated_data = response.data;
          this.supports = response.data.demand_supports;
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    getColor(status) {
      if (status == "execution")
        return {
          color: "warning",
          value: "Em execução",
        };
      else if (status == "completed")
        return {
          color: "success",
          value: "Concluído",
        };
      else
        return {
          color: "danger",
          value: "Recebido",
        };
    },
    generatePdf() {
      this.isLoadingPdfDownload = true;
      this.$http.secured
        .get("/api/v1/demand_supports.pdf", {
          params: { send_pdf: true },
          responseType: "arraybuffer",
        })
        .then((response) => {
          console.log(response.data);

          // Starting file donwload
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.target = "_blank";
          link.setAttribute("download", `Suporte.pdf`);
          document.body.appendChild(link);
          link.click();
          this.isLoadingPdfDownload = false;
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    async saveDemand() {
      this.formatedSupport();
      this.support.status = 'received';
      this.$refs.observer.validate();

      const validForm = await this.$refs.observer.validate();
      if (!validForm) {
        console.log("invalid Form");
        return;
      }

      const saveFormData = this.$buildFormData({
        ...this.support,
        author: null,
      }, "demand_support")

      this.$http.secured.post("/api/v1/demand_supports", saveFormData)
        .then(() => {
          this.modal.registerDemand = false;
          this.$toasted.global.defaultSuccess();
          this.getDemandSupport();
          this.getAllSupports();
          this.support = { author_id: "", subject: "", user_id: "", status: "",
            service: "", category: "", urgency: "", description: "", author: this.currentUser,
            files: [],
          };
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    setChartData() {
      const monthsYears = this.allSupports[0].months_years;
      let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      let data = [];

      months.map((month) => {
        monthsYears.map((item) => {
          if (item["extract(monthfromcreated_at)"] == month) {
            data[month - 1] = item.sum_values;
          }
        });
      });

      this.redBarChart = {
        chartData: {
          labels: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          datasets: [
            {
              label: "Suportes",
              data: data,
            },
          ],
        },
      };
    },
    formatedSupport() {
      this.support.author_id = this.support.author
        ? this.support.author.id
        : null;
      this.support.user_id = this.support.responsible
        ? this.support.responsible.id
        : null;
      this.support.category_support_id = this.support.category
        ? this.support.category.id
        : null;
      this.support.service_support_id = this.support.service
        ? this.support.service.id
        : null;
    },
    updateDemand() {
      this.isLoadingDemand = true;
      this.formatedSupport();

      this.formData = this.$buildFormData({
        ...this.support,
        author: null,
      }, "demand_support")

      this.$http.secured
        .patch(`/api/v1/demand_supports/${this.support.id}`,
          this.formData,
        )
        .then(() => {
          this.modal.registerDemand = false;
          this.modal.historyDemand = false;
          this.$toasted.global.defaultSuccess();
          this.editSupport = false;
          this.isLoadingDemand = false;
          this.getDemandSupport();
          this.getAllSupports();
        })
        .catch((error) => {
          console.log(error, "Something went wrong");
          // this.$toasted.global.defaultError();
          this.isLoadingDemand = false;
        });
    },
    openModal() {
      this.modal.registerDemand = true;
    },
    endModal(item) {
      this.endModalSelectedRow = item
      this.sendAnswer = {
        user_id: "",
        demand_support_id: item.id,
        content: "",
        description: ""
      };
      this.modal.endDemand = true;
    },
    // historyModal(item) {
    //   console.log("historyModal: ", item);
    //   this.modal.historyDemand = true;
    // },
    updateStatus() {
      let statusExecution = 0;
      let statusCompleted = 0;
      let statusReceived = 0;

      this.allSupports.map((card) => {
        if (card.status == "execution") statusExecution += 1;
        if (card.status == "completed") statusCompleted += 1;
        if (card.status == "received") statusReceived += 1;
      });

      this.selectionCard = [
        {
          title: "Recebidos",
          status: statusReceived,
        },
        {
          title: "Em Execução",
          status: statusExecution,
        },
        {
          title: "Concluídos",
          status: statusCompleted,
        },
      ];
    },
  },
};
</script>
<style>
.modal {
  overflow: auto;
}
</style>
